export default __webpack_public_path__ + "static/media/Notif - Live Session.eb2c251b.svg";